import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import type { AvatarColors, AvatarSizes } from './types';

// keeping empty strings here, so styles can be easily added without modifying any other file
// Used palette colors to keep colors consistent across themes
export const baseAvatarContainerVariants = cva('', {
  variants: {
    color: {
      primary: 'bg-brand-solid is-platform:bg-quaternary',
      gray: 'bg-quaternary',
      brand_subtle: 'bg-utility-brand-50 is-platform:bg-quaternary',
      warning: 'bg-palette-warning-500',
      blue: 'bg-palette-blue-700',
      error: 'bg-palette-error-500',
      success: 'bg-palette-success-500',
      cyan: 'bg-palette-cyan-500',
      teal: 'bg-palette-teal-500',
      lime: 'bg-palette-lime-600',
      pink: 'bg-palette-pink-500',
      rose: 'bg-palette-rose-500',
      fuchsia: 'bg-palette-fuchsia-500',
      indigo: 'bg-palette-indigo-500',
    } satisfies Record<AvatarColors, string>,
    size: {
      xxs: 'size-5 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      xs: 'size-6 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      sm: 'size-8 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      md: 'size-10 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      lg: 'size-12 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      xl: 'size-14 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
      '2xl': 'size-16 shadow-[inset_0_0_0_1px_var(--avatar-contrast-border)]',
    } satisfies Record<AvatarSizes, string>,
  },
});

export const avatarContainerVariants = (props) =>
  clsx('rounded-full', baseAvatarContainerVariants(props));

export const avatarTextVariants = cva('font-semibold is-platform:font-medium', {
  variants: {
    color: {
      primary: 'text-white is-platform:text-tertiary',
      gray: 'text-quaternary is-platform:text-tertiary',
      brand_subtle: 'text-utility-brand-500 is-platform:text-tertiary',
      warning: 'text-white',
      blue: 'text-white',
      error: 'text-white',
      success: 'text-white',
      cyan: 'text-white',
      teal: 'text-white',
      lime: 'text-white',
      pink: 'text-white',
      rose: 'text-white',
      fuchsia: 'text-white',
      indigo: 'text-white',
    } satisfies Record<AvatarColors, string>,
    size: {
      xxs: 'text-xs',
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-md',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'display-xs',
    } satisfies Record<AvatarSizes, string>,
  },
});

export const getAvatarRootStyles = (color: AvatarColors) => {
  if (color === 'brand_subtle') {
    return { '--avatar-contrast-border': 'var(--utility-brand-100)' } as React.CSSProperties;
  }
  return undefined;
};
